import Vue from 'vue';
import CheckPostageComponent from './CheckPostage.vue';
import router from '@/router';

let instance;

function isInDocument(element) {
  return document.body.contains(element);
}

function initInstance() {
  if (instance) {
    instance.$destroy();
  }

  instance = new (Vue.extend({
    ...CheckPostageComponent,
    router,
  }))({
    el: document.createElement('div'),
    // avoid missing animation when first rendered
    propsData: {
      lazyRender: false,
    },
  });
  document.body.appendChild(instance.$el);

  instance.$on('input', (value) => {
    instance.value = value;
  });
}

function CheckPostage(options) {
  return new Promise((resolve, reject) => {
    if (!instance || !isInDocument(instance.$el)) {
      initInstance();
    }
    Object.assign(instance, CheckPostage.currentOptions, options, {
      resolve,
      reject,
    });
  });
}

CheckPostage.show = (options) =>
  CheckPostage({
    value: true,
    ...options,
  });

CheckPostage.close = () => {
  if (instance) {
    instance.value = false;
  }
};

CheckPostage.currentOptions = {
  value: false,
  close() {
    if (instance) {
      instance.beforeClose?.();
      instance.value = false;
    }
  }
}

export default CheckPostage;
